export const catalogMapper = catalogArray =>
    catalogArray.map(catalog => ({
        id: catalog.id,
        text: catalog.name,
    }));
